export default __webpack_public_path__ + "static/media/pgmico(28).e97068e2.png";